import { render } from "./TableRow.vue?vue&type=template&id=73ae436e"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script